import { render, staticRenderFns } from "./topo.vue?vue&type=template&id=52db74f2&scoped=true&"
import script from "./topo.vue?vue&type=script&lang=js&"
export * from "./topo.vue?vue&type=script&lang=js&"
import style0 from "./topo.vue?vue&type=style&index=0&id=52db74f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db74f2",
  null
  
)

export default component.exports